import React, { useState } from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';

import { SignInReq } from 'services/auth.service';
import { Path, useAuthNavigator } from 'components/_hooks/use-router';
import { useAppDispatch } from 'store/store-hooks';
import { signIn } from 'components/auth/auth.slice';

import { Button } from 'components/UI/button/button';
import { InputGroup } from 'components/UI/input/input-group';
import { InputBase } from 'components/UI/input/elements/input-base';

import styles from '../_auth.module.scss';

const AuthLogin: React.FC = () => {
  const { navigateTo } = useAuthNavigator();
  const [isPending, setIsPending] = useState<boolean>(false);
  const dispatch = useAppDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<SignInReq>();

  const onSubmit: SubmitHandler<SignInReq> = async (data) => {
    try {
      setIsPending(true);
      const res = await dispatch(signIn(data)).unwrap();
      if (res.executionResult) navigateTo(Path.pulseIntro);
      else toast.error('Check your username or password!');
    } finally {
      setIsPending(false);
    }
  };

  return (
    <div className={styles.Login}>
      <h3 className={styles.title}>Sign In</h3>
      <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
        <InputGroup header="Username" error={errors.username?.message}>
          <InputBase
            placeholder="Enter username"
            {...register('username', { required: 'The Username is required' })}
            alert={!!errors.username?.message}
          />
        </InputGroup>
        <InputGroup header="Password" error={errors.password?.message}>
          <InputBase
            type="password"
            placeholder="Enter your password"
            alert={!!errors.password?.message}
            {...register('password', { required: 'The Password is required' })}
          />
        </InputGroup>

        <Button disabled={isPending || !!Object.keys(errors).length}>Sign In</Button>
        <p>
          <Link to={Path.resetCode}>Forgot password?</Link>
        </p>
      </form>
    </div>
  );
};

export { AuthLogin };
